/**
 * SearchSortOrderSelect Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { FormProps, reduxForm } from 'redux-form';

import { IQueryStringContext, QueryStringContext } from '../../../../contexts/queryString';
import { SortOrderSerializer } from '../../../../contexts/queryString/sortOrder';
import Select, { ISelectProps } from './';

import './sort-order-select.scss';

interface ISortingOption {
  value: string;
  label: string;
}

interface IOwnStateProps extends Pick<SearchSortOrderSelectProps, 'initialValues'> {
  sortingOptions: ISortingOption[];
  sort?: GQL.ISearchSortOrder;
}

interface IOwnProps {
  className?: string;
  selectProps?: Partial<ISelectProps>;
}

type SearchSortOrderSelectProps =
  & IOwnProps
  & IOwnStateProps
  & FormProps<any, any, any>
  & IQueryStringContext;

const classes = new BEM('sort-order-select');
const form = 'sort-order-select';

const sortingOptions: ISortingOption[] = [{
  label: 'Featured',
  value: SortOrderSerializer.serialize({
    field: GQL.SearchSortField.Featured,
    order: GQL.SearchSortOrderDirection.Desc,
  }),
  }, {
  label: 'Rating',
  value: SortOrderSerializer.serialize({
    field: GQL.SearchSortField.Score,
    order: GQL.SearchSortOrderDirection.Desc,
  }),
}, {
  label: 'Newest',
  value: SortOrderSerializer.serialize({
    field: GQL.SearchSortField.Date,
    order: GQL.SearchSortOrderDirection.Desc,
  }),
}, {
  label: 'Price - High to Low',
  value: SortOrderSerializer.serialize({
    field: GQL.SearchSortField.Price,
    order: GQL.SearchSortOrderDirection.Desc,
  }),
}, {
  label: 'Price - Low to High',
  value: SortOrderSerializer.serialize({
    field: GQL.SearchSortField.Price,
    order: GQL.SearchSortOrderDirection.Asc,
  }),
}];

class SearchSortOrderSelect extends React.Component<SearchSortOrderSelectProps> {
  onSetSortOrder = ({ value }: ISelectStoreItem) => {
    this.props.setSearchSortOrder(SortOrderSerializer.unserializeStr(value as string));
  }

  render() {
    const { sort } = this.props;
    const selectWidthClass = sort && sort.field === GQL.SearchSortField.Price ? 'md' : 'sm';
    return (
      <form {...classes('', selectWidthClass)}>
        <Select
          form={form}
          name="sortSelect"
          onUpdate={this.onSetSortOrder}
          options={this.props.sortingOptions}
          updateOnMount={false}
          selectName="sort-order-select"
          selectProps={{
            clearable: false,
            searchable: false,
            autosize: true,
          }}
          size="small"
          {...this.props.selectProps}
        />
      </form>
    );
  }
}

const SearchSortOrderSelectForm = reduxForm({
  form,
})(SearchSortOrderSelect);

const ConnectedSearchSortOrderSelect = connect<IOwnStateProps, {}, IOwnProps & IQueryStringContext, IStoreState>(
  (state, ownProps) => ({
    initialValues: {
      sortSelect: ownProps.sort ? SortOrderSerializer.serialize(ownProps.sort) : sortingOptions[0].value,
    },
    sort: ownProps.sort,
    sortingOptions,
  }),
)(SearchSortOrderSelectForm);

export const SearchSortOrderSelectWithContext: React.SFC<IOwnProps> = (props) => (
  <QueryStringContext.Consumer>
    {(ctx) => <ConnectedSearchSortOrderSelect {...ctx} {...props} />}
  </QueryStringContext.Consumer>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/Select/SearchSortOrderSelect.tsx